import { Vue, Component, Prop } from 'vue-property-decorator';
import * as DB from 'interfaces/database';
import Template from './template.vue';

@Component({})
export default class VatInput extends Vue.extend(Template) {
	@Prop({
		type: Object,
		required: true,
	})
	public readonly checkOffering!: Record<number, DB.RegionOfferingModel>;

	@Prop({
		type: Object,
		required: true,
	})
	public readonly data!: DB.OfferingModel;
}
